var _ = require('underscore');

module.exports = function() {
  if (window.console && window.console.log) {
    _.each(arguments, function(arg) {
      window.console.log(arg);
    });
  }
};
